const planStructure = [
  { label: 'Компетенция', desc: 'что развиваем' },
  { label: 'Текущий уровень', desc: 'что есть сейчас' },
  { label: 'Желаемый уровень', desc: 'куда стремимся' },
  { label: 'Действие', desc: 'что конкретно делаем' },
  { label: 'Срок', desc: 'когда' },
  { label: 'Критерий результата', desc: 'как поймём, что получилось' },
];

export default function IndividualPlans() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Индивидуальные планы развития
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Результат оценки превращается в конкретный план развития для сотрудника.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-10">
          {planStructure.map((item, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 p-5 hover:border-teal-200 transition-colors">
              <div className="text-sm font-bold text-teal-600 mb-1">{item.label}</div>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl border border-gray-200 p-6 md:p-8">
          <h3 className="text-lg font-bold text-gray-900 mb-4">Пример практической формулировки</h3>
          <p className="text-sm md:text-base text-gray-500 line-through mb-2">
            «Развивать навыки коммуникации»
          </p>
          <p className="text-sm md:text-base text-gray-800 leading-relaxed">
            «Провести 5 сложных переговоров по новой структуре, получить обратную связь руководителя и тренера, разобрать результаты и повторить практику»
          </p>
        </div>
      </div>
    </section>
  );
}